import styled from 'styled-components'

export const ExpenseTypeLabelStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
`
